import { token } from '@atlaskit/tokens';
import styled from 'styled-components';

export const FieldNameViewContainer = styled.span`
  color: ${token('color.text.subtle', '#7A869A')};
`;
